<template>
    <div v-if="mode === 'user' && entitiesLoaded"
        :class="{
            'w-chat__widget chat-user': true,
            'minimize': widget,
            'preview-chat': previewMode === 'chat-preview'
        }"><!--add minimize class for small chat-->
        <div class="conversation-screen">
            <vue-custom-scrollbar
                :swicher="activeScrollSidebar"
                id="conversation-user-scroll"
                class="conversation user-modal user"
                :settings="scrollBarSettings"
                :class="{'disable-scroll': !activeScrollSidebar}"
                :style="{'position': disableScroll ? 'static' : 'relative'}"
            >
                <div class="header">

                    <div class="info user" @click="chatProfileClick()"
                        :class="{'meet_now':user.meet_now,'online': user.isOnline, 'was-online': user.wasRecentlyOnline && !user.isOnline}">
                        <div class="img" 
                            :class="{'is-deleted': user.deleted_at}" 
                            :style="!user.deleted_at && {'background': `url(${user.photo_small}) no-repeat center / cover`}">
                        </div>
                        <div class="col">
                            <div class="name">
                              <div class="headline notranslate">{{ user.headline }}&nbsp;</div>
                              <div class="handle notranslate">@{{ user.handle }}</div>
                            </div>
                            <div class="how-far notranslate">{{ getDistanceString(user) }}</div>
                        </div>
                    </div>
                    <div class="controls">
                        <div v-if="previewMode === 'chat-preview'" class="hide-button" @click="hideChat('user', false, user.id); clearHiddenChat(user.id);">
                            <i class="hide-button--icon"></i>
                        </div>
                        <i class="trash" @click="removeConversation(user.id); finishConversation();"></i>
                        <i class="back" @click="finishConversation(); clearHiddenChat(user.id);"></i>
                    </div>
                </div>
                <ChatComponent
                    :chatMode="chatMode"
                    :userId="user.id"
                    :conversation_id="conversation_id"
                    @changeScrollBarState="changeScrollBarState"
                    @changeScrollStyle="changeScrollStyle"
                >
                </ChatComponent>

                <MediaWatcher ref="mediaWatcherClipBoardPhoto" :items="[{id:1,'photo_orig' : clipboardFileUrl}]" type="photo" :fullscreen="true"></MediaWatcher>
                <ChatPhotosReveals></ChatPhotosReveals>
                <ChatVideosReveals></ChatVideosReveals>
            </vue-custom-scrollbar>
        </div>
    </div>
</template>

<script>
    import ChatComponent from '@chat/views/widgets/ChatComponent.vue';
    import ChatPhotosReveals from '@chat/views/widgets/ChatPhotosReveals.vue';
    import ChatVideosReveals from '@chat/views/widgets/ChatVideosReveals.vue';
    import {mapState} from 'vuex';
    import chatModule from "../../module/store/type";

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"
    import MediaWatcher from "../../../buddy/views/widgets/MediaWatcher.vue";

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-chat').default,

        ],
        components: {
          MediaWatcher,
            ChatComponent,
            ChatPhotosReveals,
            ChatVideosReveals,
            vueCustomScrollbar
        },
        data() {
            return {
                activeScrollSidebar: true,
                chatMode: 'user',
                disableScroll: true,
                scrollBarSettings: {
                    suppressScrollY: false,
                    suppressScrollX: true
                },
              clipboardFileUrl: false
            }
        },
        computed: {
            entitiesLoaded(){
                return !!this.user
            },
            ...mapState({
                user: state => state.chatModule.modal.user,
                conversation_id: state => state.chatModule.modal.conversation_id,
                mode: state => state.chatModule.modal.mode,
                previewMode: state => state.chatModule.modal.previewMode,
                minimized: state => state.chatModule.modal.minimized,
                widget: state => state.chatModule.modal.widget,
                blockedUsersIds: state => state.blockedUsersIds,
            })
        },
        watch: {
            blockedUsersIds: function(blockedUsersIds) {
                if (blockedUsersIds.includes(this.user?.id)) {
                    this.finishConversation()
                }
            }
        },
        methods: {
            clearHiddenChat(userId) {
                let allConv = this.$store.getters[chatModule.getters.conversations.all];

                let index = _.findIndex(allConv, function (conv) {
                    return conv.chatType === 'user' && conv.interlocutor.id === userId;
                })
                if(index !== -1){
                  let currentConv = allConv[index];
                  currentConv.active = false;

                  this.$set(allConv, index, currentConv);
                }
            },
            changeScrollBarState(value) {
                this.activeScrollSidebar = value;
            },
            changeScrollStyle(activeScrollSidebar, disableScroll) {
                this.activeScrollSidebar = activeScrollSidebar;
                this.disableScroll = disableScroll;
            },
            scrollToBottom() {
                if (app.isMobile) {
                    const scrollElement = this.$el.querySelector('#js-chat-user-cmp').lastElementChild;
                    this.$nextTick(() => {
                      scrollElement.scrollIntoView({block: "center"})
                    });
                } else {
                    const containerName = this.chatMode.toLowerCase();
                    const scrollDiv = document.getElementById(`conversation-user-scroll`);

                    const lastMessageElem = this.$el.querySelector('#js-chat-user-cmp').lastElementChild;
                    const coordinates = scrollDiv.scrollHeight - lastMessageElem.offsetHeight;

                    this.$nextTick(() => {
                      scrollDiv.scroll({
                        top: coordinates,
                      })
                    })
                }
            },
            chatProfileClick() {
                if (this.minimized) {
                    this.maximizeChat();
                } else {
                    this.openUserModal(this.user.id, 5);
                }
            }
        },
        mounted(){
            /*console.log('[ModalChatDesktopComponent] mounted', {
                user: this.user
            })*/
          let self = this;
          app.$on('show-clipboard-photo', function(fileUrl){
            self.clipboardFileUrl = fileUrl;
            self.$refs.mediaWatcherClipBoardPhoto.show(1);
          });
        },
      beforeDestroy() {
          app.$off('show-clipboard-photo');
        },
    }
</script>